export enum ProfileType {
  COMPANY = 'company',
  INVESTOR = 'investor',
  INVESTMENT_VEHICLE = 'investmentVehicle ',
  FUND_PORTFOLIO = 'fund_portfolio',
  FUND_COMPANY = 'fund_company',
}
